import React from 'react';
import clsx from 'clsx';
import { Accordion } from '../Accordion';
import './Categories.css';
import Checkbox from '../Checkbox';
import ChevronDownIcon from '../../assets/icons/chevron-down.svg';

const Categories = ({ values, onChange }) => {
  const onClick = (item) => {
    const selected = values.find(it => it.label === item.label);
    selected.checked = !selected.checked;
    onChange([...values])
  }

  return <Accordion header={(isOpen) => (
    <div className="row space-between categories-header">
      Tracks
      <img src={ChevronDownIcon} alt="Chevron" className={clsx(isOpen && 'expanded')} />
    </div>
  )}><div className="categories">
    {values.map((item, index) => (
      <Checkbox key={index} label={item.label} checked={item.checked} onClick={() => onClick(item)} />
    ))}
  </div>
  </Accordion>;
}

export default Categories;
